/**
 * Renders the orthogonal verification axes a `CitedValue` carries as separate
 * small badges (§12) — never a single "verified" pill. Absent axes are omitted.
 */

import type { CitedValue } from "../../types/citationArtifact";
import {
	DIMENSION_TONE_CLASSES,
	deriveVerificationDimensions,
} from "./verification";

interface VerificationBadgesProps {
	value: CitedValue;
	className?: string;
}

export function VerificationBadges({
	value,
	className,
}: VerificationBadgesProps) {
	const dimensions = deriveVerificationDimensions(value);
	if (dimensions.length === 0) return null;

	return (
		<div className={`flex flex-wrap items-center gap-1 ${className ?? ""}`}>
			{dimensions.map((dim) => (
				<span
					key={dim.axis}
					title={dim.title}
					className={`inline-flex items-center gap-1 rounded border px-1.5 py-0.5 text-xs font-medium ${DIMENSION_TONE_CLASSES[dim.tone]}`}
				>
					<span className="opacity-70">{dim.label}</span>
					<span>{dim.value}</span>
				</span>
			))}
		</div>
	);
}

export default VerificationBadges;
